import requests from "./httpService";

const InvestmentServices = {
    getAllInvestment : async () =>{
        return requests.get(`/investment/`);
    },

    getInvestment : async (id) =>{
        return requests.get(`/investment/${id}`);
    },
    createInvestment : async (body) =>{

        return requests.post(`/investment`,body);
    },
    updateInvestment : async (id,body) =>{

        return requests.patch(`/investment/${id}`,body);
    },
   

}

export default InvestmentServices;